const en = {
  message: {
    "NEW 2021 Report": "NEW 2021 Report",
    "Finding 2020 Report": "Finding 2020 Report",
    "Incident Timeline": "Incident Timeline",
    "Incident map": "Incident map",
    "Report an incident": "Report an incident",
    "Timeline of Recent Anti-Asian Incidents":
      "Timeline of Recent Anti-Asian Incidents",
    Resources: "Resources",
    Reports: "Reports",
    About: "About",
    "Anti-Racism Campaign": "Anti-Racism Campaign",
    "Legal Support": "Legal Support",
    "Health and Mental Health Resources": "Health and Mental Health Resources",
    "Income Support Resources": "Income Support Resources",
    "Support Migrant Rights": "Support Migrant Rights",
    "Support Paid Sick Days for Workers": "Support Paid Sick Days for Workers",
    Phone: "Phone",
    Email: "Email",
    "Police Alternatives": "Police Alternatives",
    "Petition: Sex Workers Income Support":
      "Petition: Sex Workers Income Support",
    Podcast: "Podcast",
    Myths: "Myths",
  },
};

const fr = {
  message: {
    "NEW 2021 Report": "Constats : rapport 2021",
    "Finding 2020 Report": "Constats : rapport 2020",
    "Incident Timeline": "Chronologie des incidents",
    "Incident map": "Carte des incidents",
    "Report an incident": "Dénoncer un incident",
    "Timeline of Recent Anti-Asian Incidents":
      "Chronologie des incidents anti-asiatiques récents",
    Resources: "Ressources",
    Reports: "Rapports",
    About: "À propos",
    "Anti-Racism Campaign": "Campagne contre le racism",
    "Legal Support": "Appui légal",
    "Health and Mental Health Resources":
      "Ressources de santé et santé mentale",
    "Income Support Resources": "Ressources de soutien financier",
    "Support Migrant Rights": "Appuyer les droits des migrants",
    "Support Paid Sick Days for Workers":
      "Revendiquer les congés de maladie payés pour les travailleurs et travailleuses",
    Phone: "Téléphone",
    Email: "Email",
    "Police Alternatives": "Police Alternatives",
    "Petition: Sex Workers Income Support":
      "Petition: Sex Workers Income Support",
    Podcast: "Podcast",
    Myths: "Myths",
  },
};

// Simplified
const zhcn = {
  message: {
    "NEW 2021 Report": "2021 报告发现",
    "Finding 2020 Report": "2020 报告发现",
    "Incident Timeline": "事件时间线",
    "Incident map": "事件地图",
    "Report an incident": "报告一个事件",
    "Timeline of Recent Anti-Asian Incidents": "最近的反亚裔事件时间线",
    Resources: "资源页",
    Reports: "报告",
    About: "关于",
    "Anti-Racism Campaign": "反对歧视亚裔运动",
    "Legal Support": "法律质询",
    "Health and Mental Health Resources": "健康和心里健康信息",
    "Income Support Resources": "收入保障信息",
    "Support Migrant Rights": "支持移民权益！",
    "Support Paid Sick Days for Workers": "支持工人权益！",
    Phone: "电话",
    Email: "邮",
    "Police Alternatives": "Police Alternatives",
    "Petition: Sex Workers Income Support":
      "Petition: Sex Workers Income Support",
    Podcast: "播客",
    Myths: "Myths",
  },
};

// Traditional
const zhtw = {
  message: {
    "NEW 2021 Report": "2021 報告發現",
    "Finding 2020 Report": "2020 報告發現",
    "Incident Timeline": "事件時間線",
    "Incident map": "事件地圖",
    "Report an incident": "報告一個事件",
    "Timeline of Recent Anti-Asian Incidents": "最近的反亞裔事件時間線",
    Resources: "資源頁",
    Reports: "報告",
    About: "關於",
    "Anti-Racism Campaign": "反對歧視亞裔運動",
    "Legal Support": "法律質詢",
    "Health and Mental Health Resources": "健康和心裡健康信息",
    "Income Support Resources": "收入保障信息",
    "Support Migrant Rights": "支持移民權益！",
    "Support Paid Sick Days for Workers": "支持工人權益！",
    Phone: "電話",
    Email: "郵",
    "Police Alternatives": "Police Alternatives",
    "Petition: Sex Workers Income Support":
      "Petition: Sex Workers Income Support",
    Podcast: "播客",
    Myths: "Myths",
  },
};

// Ready translated locale messages
export default { en, fr, zhcn, zhtw };
